export default __webpack_public_path__ + "static/media/Star.bc217c1f.svg";